import { PieceAssetSize, PieceAssetType } from '@apiContract';
import { getUploadUrl } from 'src/api/piece';

import { apiRequest } from '@src/api/apiRequest';
import { uploadImageToS3 } from '@src/api/imageS3';
import { resizeImage } from '@utils/image';

export const uploadValidationImage = async (pieceId: number, imageSrc: string): Promise<string> => {
  const { pieceAssets } = await getUploadUrl(pieceId);

  const { url, key } =
    pieceAssets.find(
      (asset) =>
        asset.pieceAssetType === PieceAssetType.ValidationImage && asset.pieceAssetSize === PieceAssetSize.Large,
    ) || {};

  if (!url || !key) {
    throw new Error('No upload URL for validation image');
  }

  const resizedImage = await resizeImage(imageSrc, 4096, 4096);

  await apiRequest(
    uploadImageToS3,
    {
      image: resizedImage,
      uploadUrl: url,
      contentType: 'image/jpg',
    },
    false,
    5,
  );

  return key;
};
